<template>
  <div class="register-tcp">
    <div class="Agreement_box">
      <!-- <h3 class="Agreement_box_close"> -->
      <!-- 极联服务协议 -->
      <!-- </h3> -->
      <div class="Agreement_info">
        <p class="MsoNormal">
          <span
            ><span
              ><span style="">
                在您注册成为极联用户的过程中，您需要完成我们的注册流程并通过勾兑我已阅读并同意的形式在线签署以下协议，请您务必仔细阅读、充分理解协议中的条款内容后再勾兑我已阅读并同意（尤其是以粗体并下划线标识的条款，因为这些条款可能会明确您应履行的义务或对您的权利有所限制）：
              </span></span
            ></span
          ><span
            ><span><span style=""></span></span
          ></span>
        </p>
        <p class="MsoNormal">
          <span
            ><span><span style="">&nbsp;</span></span></span
          >
        </p>
        <p class="MsoNormal">
          <span
            ><span
              ><span style=""><span>《极联服务协议》</span></span></span
            ></span
          ><span
            ><span><span style=""></span></span
          ></span>
        </p>
        <p class="MsoNormal">
          <span
            ><span
              ><span style=""><span>一、极联服务条款的确认和接纳</span></span></span
            ></span
          ><span
            ><span><span style=""></span></span
          ></span>
        </p>
        <p class="MsoNormal">
          <span
            ><span
              ><span style=""><span>二、极联服务</span></span></span
            ></span
          ><span
            ><span><span style=""></span></span
          ></span>
        </p>
        <p class="MsoNormal">
          <span
            ><span
              ><span style=""><span>三、用户信息</span></span></span
            ></span
          ><span
            ><span><span style=""></span></span
          ></span>
        </p>
        <p class="MsoNormal">
          <span
            ><span
              ><span style=""><span>四、用户依法言行义务</span></span></span
            ></span
          ><span
            ><span><span style=""></span></span
          ></span>
        </p>
        <p class="MsoNormal">
          <span
            ><span
              ><span style=""><span>五、商品信息</span></span></span
            ></span
          ><span
            ><span><span style=""></span></span
          ></span>
        </p>
        <p class="MsoNormal">
          <span
            ><span
              ><span style=""><span>六、订单</span></span></span
            ></span
          ><span
            ><span><span style=""></span></span
          ></span>
        </p>
        <p class="MsoNormal">
          <span
            ><span
              ><span style=""><span>七、配送</span></span></span
            ></span
          ><span
            ><span><span style=""></span></span
          ></span>
        </p>
        <p class="MsoNormal">
          <span
            ><span
              ><span style=""><span>八、所有权及知识产权条款</span></span></span
            ></span
          ><span
            ><span><span style=""></span></span
          ></span>
        </p>
        <p class="MsoNormal">
          <span
            ><span
              ><span style=""><span>九、责任限制及不承诺担保</span></span></span
            ></span
          ><span
            ><span><span style=""></span></span
          ></span>
        </p>
        <p class="MsoNormal">
          <span
            ><span
              ><span style=""><span>十、协议更新及用户关注义务</span></span></span
            ></span
          ><span
            ><span><span style=""></span></span
          ></span>
        </p>
        <p class="MsoNormal">
          <span
            ><span
              ><span style=""
                ><span>十一、法律管辖和适用《法律声明及隐私权政策》</span></span
              ></span
            ></span
          ><span></span>
        </p>
        <p class="MsoNormal">
          <span>&nbsp;</span>
        </p>
        <p class="MsoNormal">
          <span
            ><span
              >【审慎阅读】您在申请注册流程中勾兑同意前，应当认真阅读以下协议。请您务必审慎阅读、充分理解协议中相关条款内容，其中包括：</span
            ></span
          ><span></span>
        </p>
        <p class="MsoNormal">
          <span>1.与您约定免除或者限制责任的条款；</span><span></span>
        </p>
        <p class="MsoNormal">
          <span>2.与您约定法律适用和管辖的条款；</span><span></span>
        </p>
        <p class="MsoNormal">
          <span>3.其他以粗体下划线标识的重要条款。</span><span></span>
        </p>
        <p class="MsoNormal">
          <span
            ><span
              ><span style=""
                ><span
                  >【请您注意】如果您不同意上述协议或其中任何条款约定，请您停止注册。您停止注册后将仅可以浏览我们的商品信息但无法享受我们的产品或服务。如您按照注册流程提示填写信息、勾兑我已阅读并同意上述协议且完成全部注册流程后，即表示您已充分阅读、理解并接受协议的全部内容；并表明您也同意极联可以依据以上的隐私政策内容来处理您的个人信息。</span
                ></span
              ></span
            ></span
          ><span
            ><span
              >如您对以上协议内容有任何疑问，您可随时通过极联网站的联系方式联系我们。</span
            ></span
          ><span></span>
        </p>
        <p class="MsoNormal">
          <span
            ><span
              ><span style=""><span>勾兑同意即表示您已阅读并同意</span></span></span
            ></span
          ><span
            ><span
              ><span style=""><span>《极联服务协议》</span></span></span
            ></span
          ><span
            ><span
              ><span style=""
                ><span
                  >，并同意我们将您的订单信息共享给为完成此订单所必须的第三方合作方（详情查看【</span
                ></span
              ></span
            ></span
          ><span
            ><span
              ><span style=""><span>订单共享与安全</span></span></span
            ></span
          ><span
            ><span
              ><span style=""><span>】）</span></span></span
            ></span
          ><span
            ><span><span style=""></span></span
          ></span>
        </p>
        <p class="MsoNormal">
          <span><span>如您对协议有任何疑问，可向我们的客服咨询。</span></span
          ><span></span>
        </p>
        <p class="MsoNormal">
          <span
            ><span
              >【特别提示】当您按照注册页面提示填写信息、勾兑我已阅读并同意协议且完成全部注册程序后，即表示您已充分阅读、理解并接受协议的全部内容。如您在使用平台服务过程中与其他用户发生争议的，依您与其他用户达成的协议处理。</span
            ></span
          ><span></span>
        </p>
        <p class="MsoNormal">
          <span
            ><span
              >阅读协议的过程中，如果您不同意相关协议或其中任何条款约定，您应立即停止注册程序。</span
            ></span
          ><span></span>
        </p>
        <p class="MsoNormal">
          <span>&nbsp;</span>
        </p>
        <p class="MsoNormal">
          <span
            ><span style="u-size: 16pt"><span>极联服务协议</span></span></span
          ><span><span style="u-size: 16pt"></span></span>
        </p>
        <p class="MsoNormal">
          <span
            ><span>本协议是您与极联网站（简称</span>&#8220;极联&#8221;，网址：</span
          ><span>http://XXXXXXXX</span
          ><span
            ><span
              >）之间就极联网站服务等相关事宜所订立的契约，请您仔细阅读本注册协议，您勾兑我已阅读并同意《极联服务协议》后，本协议即构成对双方有约束力的法律文件。
            </span></span
          ><span></span>
        </p>
        <p class="MsoNormal">
          <span>&nbsp;</span>
        </p>
        <p class="MsoNormal">
          <span><span>一、极联服务条款的确认和接纳</span></span
          ><span></span>
        </p>
        <p class="MsoNormal">
          <span
            >1.1极联的各项电子服务的所有权和运作权归极联所有。用户同意所有注册协议条款并完成注册程序，才能成为极联的正式用户。用户确认：本协议条款是处理双方权利义务的契约，始终有效，法律另有强制性规定或双方另有特别约定的，依其规定。</span
          ><span></span>
        </p>
        <p class="MsoNormal">
          <span
            >1.2用户勾兑我已阅读并同意本协议的，即视为用户确认自己具有享受极联服务、下单购物等相应的权利能力和行为能力，能够独立承担法律责任。</span
          ><span></span>
        </p>
        <p class="MsoNormal">
          <span
            >1.3如果您在18周岁以下，您只能在父母或监护人的监护参与下才能使用极联。</span
          ><span></span>
        </p>
        <p class="MsoNormal">
          <span
            >1.4极联保留在中华人民共和国大陆地区法施行之法律允许的范围内独自决定拒绝服务、关闭用户账户、清除或编辑内容或取消订单的权利。</span
          ><span></span>
        </p>
        <p class="MsoNormal">
          <span>&nbsp;</span>
        </p>
        <p class="MsoNormal">
          <span><span>二、极联服务</span></span
          ><span></span>
        </p>
        <p class="MsoNormal">
          <span
            >2.1极联通过互联网依法为用户提供互联网信息等服务，用户在完全同意本协议及极联规定的情况下，方有权使用极联的相关服务。</span
          ><span></span>
        </p>
        <p class="MsoNormal">
          <span>2.2用户必须自行准备如下设备和承担如下开支：</span><span></span>
        </p>
        <p class="MsoNormal">
          <span
            ><span>（</span
            >1）上网设备，包括并不限于电脑或者其他上网终端、调制解调器及其他必备的上网装置；</span
          ><span></span>
        </p>
        <p class="MsoNormal">
          <span
            ><span>（</span
            >2）上网开支，包括并不限于网络接入费、上网设备租用费、手机流量费等。</span
          ><span></span>
        </p>
        <p class="MsoNormal">
          <span>&nbsp;</span>
        </p>
        <p class="MsoNormal">
          <span><span>三、用户信息</span></span
          ><span></span>
        </p>
        <p class="MsoNormal">
          <span
            >3.1用户应自行诚信向极联提供注册资料，用户同意其提供的注册资料真实、准确、完整、合法有效，用户注册资料如有变动的，应及时更新其注册资料。如果用户提供的注册资料不合法、不真实、不准确、不详尽的，用户需承担因此引起的相应责任及后果，并且极联保留终止用户使用极联各项服务的权利。</span
          ><span></span>
        </p>
        <p class="MsoNormal">
          <span
            >3.2用户在极联进行浏览、下单购物等活动时，涉及用户真实姓名/名称、通信地址、联系电话、电子邮箱等隐私信息的，极联将予以严格保密，除非得到用户的授权或法律另有规定，极联不会向外界披露用户隐私信息。</span
          ><span></span>
        </p>
        <p class="MsoNormal">
          <span
            >3.3用户注册成功后，将产生用户名和密码等账户信息，您可以根据极联规定改变您的密码。用户应谨慎合理的保存、使用其用户名和密码。用户若发现任何非法使用用户账号或存在安全漏洞的情况，请立即通知极联并向公安机关报案。</span
          ><span></span>
        </p>
        <p class="MsoNormal">
          <span
            >3.4用户同意，极联拥有通过邮件、短信、电话等形式，向在极联注册、购物用户、收货人发送订单信息、促销活动等告知信息的权利。</span
          ><span></span>
        </p>
        <p class="MsoNormal">
          <span
            >3.5用户不得将在极联注册获得的账户借给他人使用，否则用户应承担由此产生的全部责任，并与实际使用人承担连带责任。</span
          ><span></span>
        </p>
        <p class="MsoNormal">
          <span
            >3.6用户同意，极联有权使用用户的注册信息、用户名、密码等信息，登录进入用户的注册账号，进行证据保全，包括但不限于公证、见证等。</span
          ><span></span>
        </p>
        <p class="MsoNormal">
          <span>&nbsp;</span>
        </p>
        <p class="MsoNormal">
          <span><span>四、用户依法言行义务</span></span
          ><span></span>
        </p>
        <p class="MsoNormal">
          <span
            ><span
              >本协议依据国家相关法律法规规章制定，用户同意严格遵守以下义务：</span
            ></span
          ><span></span>
        </p>
        <p class="MsoNormal">
          <span
            >1.不得传输或发表：煽动抗拒、破坏宪法和法律、行政法规实施的言论，煽动颠覆国家政权，推翻社会主义制度的言论，煽动分裂国家、破坏国家统一的言论，煽动民族仇恨、民族歧视、破坏民族团结的言论；</span
          ><span></span>
        </p>
        <p class="MsoNormal">
          <span>2.从中国大陆向境外传输资料信息时必须符合中国有关法规；</span
          ><span></span>
        </p>
        <p class="MsoNormal">
          <span
            >3.不得利用极联从事洗钱、窃取商业秘密、窃取个人信息等违法犯罪活动；</span
          ><span></span>
        </p>
        <p class="MsoNormal">
          <span
            >4.不得干扰极联的正常运转，不得侵入极联及国家计算机信息系统；</span
          ><span></span>
        </p>
        <p class="MsoNormal">
          <span
            >5.不得传输或发表任何违法犯罪的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、伤害性的、庸俗的、淫秽的、不文明的等信息资料；</span
          ><span></span>
        </p>
        <p class="MsoNormal">
          <span
            >6.不得传输或发表损害国家社会公共利益和涉及国家安全的信息资料或言论；</span
          ><span></span>
        </p>
        <p class="MsoNormal">
          <span>7.不得教唆他人从事本条所禁止的行为；</span><span></span>
        </p>
        <p class="MsoNormal">
          <span>8.不得利用在极联注册的账户进行牟利性经营活动；</span
          ><span></span>
        </p>
        <p class="MsoNormal">
          <span
            >9.不得发布任何侵犯他人著作权、商标权等知识产权或合法权利的内容；</span
          ><span></span>
        </p>
        <p class="MsoNormal">
          <span
            ><span
              >用户应不时关注并遵守极联不时公布或修改的各类合法规则规定。</span
            ></span
          ><span></span>
        </p>
        <p class="MsoNormal">
          <span
            ><span
              >极联保有删除站内各类不符合法律政策或不真实的信息内容而无须通知用户的权利。</span
            ></span
          ><span></span>
        </p>
        <p class="MsoNormal">
          <span
            ><span
              >若用户未遵守以上规定的，极联有权作出独立判断并采取暂停或关闭用户账号等措施。用户须对自己在网上的言论和行为承担法律责任。</span
            ></span
          ><span></span>
        </p>
        <p class="MsoNormal">
          <span>&nbsp;</span>
        </p>
        <p class="MsoNormal">
          <span><span>五、商品信息</span></span
          ><span></span>
        </p>
        <p class="MsoNormal">
          <span
            ><span
              >极联上的商品价格、数量、是否有货等商品信息随时都有可能发生变动，极联不作特别通知。由于网站上商品信息的数量极其庞大，虽然极联会尽最大努力保证您所浏览商品信息的准确性，但由于众所周知的互联网技术因素等客观原因存在，极联网页显示的信息可能会有一定的滞后性或差错，对此情形您知悉并理解；极联欢迎纠错，并会视情况给予纠错者一定的奖励。</span
            ></span
          ><span></span>
        </p>
        <p class="MsoNormal">
          <span
            ><span>为表述便利，商品和服务简称为</span
            >&#8220;商品&#8221;或&#8220;货物&#8221;。</span
          ><span></span>
        </p>
        <p class="MsoNormal">
          <span>&nbsp;</span>
        </p>
        <p class="MsoNormal">
          <span><span>六、订单</span></span
          ><span></span>
        </p>
        <p class="MsoNormal">
          <span
            >6.1在您下订单时，请您仔细确认所购商品的名称、价格、数量、型号、规格、尺寸、联系地址、电话、收货人等信息。收货人与用户本人不一致的，收货人的行为和意思表示视为用户的行为和意思表示，用户应对收货人的行为及意思表示的法律后果承担连带责任。</span
          ><span></span>
        </p>
        <p class="MsoNormal">
          <span
            >6.2除法律另有强制性规定外，双方约定如下：极联上配件商城所展示的商品和价格等信息仅仅是交易信息的发布，您下单时须填写您希望购买的商品数量、价款及支付方式、收货人、联系方式、收货地址等内容；系统生成的订单信息是计算机信息系统根据您填写的内容自动生成的数据，仅是您向极联发出的交易诉求；极联门店收到您的订单信息后，只有在极联将您在订单中订购的商品从仓库实际直接向您发出时（以商品出库为标志），方视为您与极联之间就实际直接向您发出的商品建立了交易关系；如果您在一份订单里订购了多种商品并且极联只给您发出了部分商品时，您与极联之间仅就实际直接向您发出的商品建立了交易关系；只有在极联实际直接向您发出了订单中订购的其他商品时，您和极联之间就订单中该其他已实际直接向您发出的商品才成立交易关系。您可以随时登录您在极联注册的账户，查询您的订单状态。</span
          ><span></span>
        </p>
        <p class="MsoNormal">
          <span
            >6.3由于市场变化及各种以合理商业努力难以控制的因素的影响，极联无法保证您提交的订单信息中希望购买的商品都会有货；如您拟购买的商品，发生缺货，您有权取消订单。</span
          ><span></span>
        </p>
        <p class="MsoNormal">
          <span>&nbsp;</span>
        </p>
        <p class="MsoNormal">
          <span><span>七、配送</span></span
          ><span></span>
        </p>
        <p class="MsoNormal">
          <span
            >7.1极联门店将会把商品（货物）送到您所指定的收货地址，所有在极联上列出的送货时间为参考时间，参考时间的计算是根据库存状况、正常的处理过程和送货时间、送货地点的基础上估计得出的。</span
          ><span></span>
        </p>
        <p class="MsoNormal">
          <span
            >7.2因如下情况造成订单延迟或无法配送等，极联不承担延迟配送的责任：</span
          ><span></span>
        </p>
        <p class="MsoNormal">
          <span><span>（</span>1）用户提供的信息错误、地址不详细等原因导致的；</span
          ><span></span>
        </p>
        <p class="MsoNormal">
          <span><span>（</span>2）货物送达后无人签收，导致无法配送或延迟配送的；</span
          ><span></span>
        </p>
        <p class="MsoNormal">
          <span><span>（</span>3）情势变更因素导致的；</span><span></span>
        </p>
        <p class="MsoNormal">
          <span
            ><span>（</span
            >4）不可抗力因素导致的，例如：自然灾害、交通戒严、突发战争等。</span
          ><span></span>
        </p>
        <p class="MsoNormal">
          <span>&nbsp;</span>
        </p>
        <p class="MsoNormal">
          <span><span>八、所有权及知识产权条款</span></span
          ><span></span>
        </p>
        <p class="MsoNormal">
          <span
            ><span
              ><span style=""
                >8.1用户一旦接受本协议，即表明该用户主动将其在任何时间段在极联发表的任何形式的信息内容（包括但不限于客户评价、客户咨询、各类话题文章等信息内容）的财产性权利等任何可转让的权利，如著作权财产权（包括并不限于：复制权、发行权、出租权、展览权、表演权、放映权、广播权、信息网络传播权、摄制权、改编权、翻译权、汇编权以及应当由著作权人享有的其他可转让权利），全部独家且不可撤销地转让给极联所有，用户同意极联有权就任何主体侵权而单独提起诉讼。</span
              ></span
            ></span
          ><span
            ><span><span style=""></span></span
          ></span>
        </p>
        <p class="MsoNormal">
          <span
            >8.2本协议已经构成《中华人民共和国著作权法》第二十五条（条文序号依照2011年版著作权法确定）及相关法律规定的著作财产权等权利转让书面协议，其效力及于用户在极联网站上发布的任何受著作权法保护的作品内容，无论该等内容形成于本协议订立前还是本协议订立后。</span
          ><span></span>
        </p>
        <p class="MsoNormal">
          <span
            >8.3用户同意并已充分了解本协议的条款，承诺不将已发表于极联的信息，以任何形式发布或授权其它主体以任何方式使用（包括但不限于在各类网站、媒体上使用）。</span
          ><span></span>
        </p>
        <p class="MsoNormal">
          <span
            >8.4极联是极联的制作者,拥有此网站内容及资源的著作权等合法权利,受国家法律保护,有权不时地对本协议及极联的内容进行修改，并在极联网站张贴，无须另行通知用户。在法律允许的最大限度范围内，极联对本协议及极联内容拥有解释权。</span
          ><span></span>
        </p>
        <p class="MsoNormal">
          <span
            ><span style=""
              >8.5除法律另有强制性规定外，未经极联明确的特别书面许可,任何单位或个人不得以任何方式非法地全部或部分复制、转载、引用、链接、抓取或以其他方式使用极联的信息内容，否则，极联有权追究其法律责任。</span
            ></span
          ><span><span style=""></span></span>
        </p>
        <p class="MsoNormal">
          <span
            >8.6极联所刊登的资料信息（诸如文字、图表、标识、按钮图标、图像、声音文件片段、数字下载、数据编辑和软件），均是极联或其内容提供者的财产，受中国和国际版权法的保护。极联上所有内容的汇编是极联的排他财产，受中国和国际版权法的保护。极联上所有软件都是极联或其关联公司或其软件供应商的财产，受中国和国际版权法的保护。</span
          ><span></span>
        </p>
        <p class="MsoNormal">
          <span>&nbsp;</span>
        </p>
        <p class="MsoNormal">
          <span><span>九、责任限制及不承诺担保</span></span
          ><span></span>
        </p>
        <p class="MsoNormal">
          <span
            ><span
              ><span style=""
                ><span>除非另有明确的书面说明</span
                >,极联及其所包含的或以其它方式通过极联提供给您的全部信息、内容、材料、产品（包括软件）和服务，均是在&#8220;按现状&#8221;和&#8220;按现有&#8221;的基础上提供的。</span
              ></span
            ></span
          ><span
            ><span><span style=""></span></span
          ></span>
        </p>
        <p class="MsoNormal">
          <span
            ><span
              ><span style=""
                ><span>除非另有明确的书面说明</span
                >,极联不对极联的运营及其包含在本网站上的信息、内容、材料、产品（包括软件）或服务作任何形式的、明示或默示的声明或担保（根据中华人民共和国法律另有规定的以外）。</span
              ></span
            ></span
          ><span
            ><span><span style=""></span></span
          ></span>
        </p>
        <p class="MsoNormal">
          <span
            ><span><span style="">&nbsp;</span></span></span
          >
        </p>
        <p class="MsoNormal">
          <span
            ><span
              ><span style=""
                ><span
                  >极联不担保极联所包含的或以其它方式通过极联提供给您的全部信息、内容、材料、产品（包括软件）和服务、其服务器或从极联发出的电子信件、信息没有病毒或其他有害成分。</span
                ></span
              ></span
            ></span
          ><span
            ><span><span style=""></span></span
          ></span>
        </p>
        <p class="MsoNormal">
          <span
            ><span><span style="">&nbsp;</span></span></span
          >
        </p>
        <p class="MsoNormal">
          <span
            ><span
              ><span style=""
                ><span
                  >如因不可抗力或其它极联无法控制的原因使极联销售系统崩溃或无法正常使用导致网上交易无法完成或丢失有关的信息、记录等，极联会合理地尽力协助处理善后事宜。</span
                ></span
              ></span
            ></span
          ><span
            ><span><span style=""></span></span
          ></span>
        </p>
        <p class="MsoNormal">
          <span>&nbsp;</span>
        </p>
        <p class="MsoNormal">
          <span><span>十、协议更新及用户关注义务</span></span
          ><span></span>
        </p>
        <p class="MsoNormal">
          <span
            ><span
              >根据国家法律法规变化及网站运营需要，极联有权对本协议条款不时地进行修改，修改后的协议一旦被张贴在极联上即生效，并代替原来的协议。用户可随时登录查阅最新协议；</span
            ></span
          ><span></span>
        </p>
        <p class="MsoNormal">
          <span
            ><span
              >用户有义务不时关注并阅读最新版的协议及网站公告。如用户不同意更新后的协议，可以且应立即停止接受极联网站依据本协议提供的服务；如用户继续使用本网站提供的服务的，即视为同意更新后的协议。极联建议您在使用极联之前阅读本协议及极联的公告。</span
            ></span
          ><span></span>
        </p>
        <p class="MsoNormal">
          <span
            ><span
              >如果本协议中任何一条被视为废止、无效或因任何理由不可执行，该条应视为可分的且并不影响任何其余条款的有效性和可执行性。</span
            ></span
          ><span></span>
        </p>
        <p class="MsoNormal">
          <span>&nbsp;</span>
        </p>
        <p class="MsoNormal">
          <span><span>十一、法律管辖和适用</span></span
          ><span></span>
        </p>
        <p class="MsoNormal">
          <span
            ><span
              >本协议的订立、执行和解释及争议的解决均应适用在中华人民共和国大陆地区适用之有效法律（但不包括其冲突法规则）。</span
            ></span
          ><span></span>
        </p>
        <p class="MsoNormal">
          <span
            ><span
              >如发生本协议与适用之法律相抵触时，则这些条款将完全按法律规定重新解释，而其它有效条款继续有效。</span
            ></span
          ><span></span>
        </p>
        <p class="MsoNormal">
          <span
            ><span
              >如缔约方就本协议内容或其执行发生任何争议，双方应尽力友好协商解决；协商不成时，任何一方均可向有管辖权的中华人民共和国大陆地区法院提起诉讼。</span
            ></span
          ><span></span>
        </p>
        <p class="MsoNormal">
          <span>&nbsp;</span>
        </p>
        <p class="MsoNormal">
          <span><span>十二、其他</span></span
          ><span></span>
        </p>
        <p class="MsoNormal">
          <span
            >12.1极联网站所有者是指在政府部门依法许可或备案的极联网站经营主体。</span
          ><span></span>
        </p>
        <p class="MsoNormal">
          <span
            >12.2极联尊重用户和消费者的合法权利，本协议及本网站上发布的各类规则、声明等其他内容，均是为了更好的、更加便利的为用户和消费者提供服务。极联欢迎用户和社会各界提出意见和建议，极联将虚心接受并适时修改本协议及极联上的各类规则。</span
          ><span></span>
        </p>
        <p class="MsoNormal">
          <span
            >12.3本协议内容中以黑体、加粗、下划线、斜体等方式显著标识的条款，请用户着重阅读。</span
          ><span></span>
        </p>
        <p class="MsoNormal">
          <span
            >12.4您注册时勾兑我已阅读并同意，立即注册后即视为您完全接受本协议，在勾兑之前请您再次确认已知悉并完全理解本协议的全部内容。</span
          ><span></span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'register-tcp',
  components: {},
  data() {
    return {}
  },
  created() {},
  methods: {},
  computed: {},
  watch: {}
}
</script>
<style lang='less' scoped>
.Agreement_box {
  width: 100%;
}

.Agreement_box h3 {
  u-size: 18px;
  // color: #666;
  // u-weight: 600;
  text-align: center;
  padding: 10px;
  background: #f8f8f8;
}

.Agreement_info {
  width: 100%;
  padding: 20px;
}

.Agreement_box p {
  text-indent: 2em;
  text-align: justify;
  text-justify: inter-ideograph;
  line-height: 20px;
  margin-bottom: 5px;
}

.agrement_btn {
  text-align: center;
}

.agrement_btn a {
  display: inline-block;
  width: 200px;
  height: 50px;
  margin-top: 20px;
  // u-size: 18px;
  line-height: 50px;
}

.agrement_qx {
  // background: #f8f8f8;
}

.agrement_ty {
  // background: #d3001e;
  // color: #fff;
  margin-left: 10px;
}

.agrement_ty:hover {
  // color: #fff;
}

.Agreement_info::-webkit-scrollbar {
  width: 6px;
  height: 16px;
  // background-color: #ddd;
}

.Agreement_info::-webkit-scrollbar-thumb {
  // background: #aaa;
}

.MsoNormal {
  span {
    // u-family: 微软雅黑;
    //
    //
    //
  }
}
</style>